import Image from 'next/image';
import { useRouter } from 'next/router';
import { useState } from 'react';
import { getVideoUrl } from '../../../Utils/helper';
import { VideoContainer } from '../../ProductNew/VideoReviews/styled';
import UserImagesCustomSection from './UserImagesCustomSection';
import { useIsDesktop } from '../../../Utils/productPageUtils';
import { fireVedioClickEvent, ParamToAdd } from './utils';
import DDPriceUnitStrip from './FullscreenCarousel/DDPriceUnitStrip';

export default function ImageGalleryItem(props) {
  const {
    item,
    setShowPopup,
    setvideoData,
    product,
    productName,
    gesture,
    user_review_images,
    setShowCarouselPopup,
    total_count_images,
    parent,
    isFertilityProduct,
    videoRef,
    userType,
    showNewDiaperVariantUx,
  } = props;
  const router = useRouter();
  const [videoGesture, setVideoGesture] = useState(false);
  const isDesktop = useIsDesktop();

  const onVideoImageClickHandler = (item) => {
    setVideoGesture(true);
    setTimeout(() => {
      fireVedioClickEvent(item, product);
      setShowPopup(true);
      setvideoData(`https://www.youtube.com/watch?v=${item.videoId}`);
      const params = new URLSearchParams(window.location.search);
      params.set(ParamToAdd, 'true');
      router.push(router.asPath + '?' + params, undefined, {
        shallow: true,
        scroll: false,
      });
      setVideoGesture(false);
    }, 50);
  };

  const user_review_section = item.type === 'custom';
  return (
    <div
      style={{ opacity: videoGesture ? 0.4 : 1 }}
      id={item.original == 'video' ? 'video-container' : ''}
      className={
        user_review_section
          ? 'customImageDiv'
          : item.original == 'video' && !isDesktop
            ? 'videoPlayerDiv'
            : 'defaultImageDiv'
      }
    >
      {user_review_section ? (
        <UserImagesCustomSection
          user_review_images={user_review_images}
          setShowCarouselPopup={setShowCarouselPopup}
          showCta={true}
          product={product}
          index={item.index}
          total_count_images={total_count_images}
          parent={parent}
        />
      ) : item.original == 'video' ? (
        isDesktop ? (
          <>
            <div onClick={() => onVideoImageClickHandler(item)}>
              <img
                className="ImagePlayButton"
                src="/images/video_play.svg"
                alt="video_play_button"
                loading="lazy"
              />
            </div>
            <img
              className="image-gallery-image  mainImage"
              src={`https://i.ytimg.com/vi_webp/${item.videoId}/sddefault.webp`}
              alt={productName}
              loading={item.index !== 0 && 'lazy'}
            />
          </>
        ) : (
          <VideoContainer
            id={'yt-player1'}
            ref={videoRef}
            type="text/html"
            src={getVideoUrl(item?.videoId, 1, 1)}
            frameBorder="0"
            allowFullScreen
            lazyload={true}
            allow="autoplay"
          ></VideoContainer>
        )
      ) : (
        <>
          <Image
            src={item.original}
            alt={
              isFertilityProduct
                ? 'mylo ovaluna tablet'
                : item.image_alt_text || productName
            }
            loading={item.index == 0 ? 'eager' : 'lazy'}
            priority={item.index == 0}
            quality={90}
            fill
            sizes="60vw"
          />

          {/* {item.index == 0 &&
                        showNewDiaperVariantUx &&
                        userType == "A" && (
                            <DDPriceUnitStrip productData={product} />
                        )} */}
          {/* {!isFertilityProduct && product?.id !== 979 ? (
                        <span className="image-gallery-description">
                            {item.description}
                        </span>
                    ) : null} */}
        </>
      )}
    </div>
  );
}
